import React, { useEffect } from "react"
import { Card, CardBody, Row, Col, Label, Input, Button } from "reactstrap"
import { useFormik } from "formik"
import * as Yup from "yup"
import { useSelector } from "react-redux"

const Info = props => {
  const user = useSelector(state => state.auth.user)

  useEffect(() => {
    formik.setValues({
      firstname: user && user.first_name ? user.first_name : "",
      lastname: user && user.last_name ? user.last_name : "",
      email: user && user.email_id ? user.email_id : "",
      whatsapp: user && user.mobile_no ? user.mobile_no : "",
      contact: user && user.contact_no ? user.contact_no : "",
      instagram: user && user.instagram_link ? user.instagram_link : "",
      facebook: user && user.facebook_link ? user.facebook_link : "",
      linkedin: user && user.linkedin_link ? user.linkedin_link : "",
      website: user && user.website_link ? user.website_link : "",
    })
  }, [user])

  const formik = useFormik({
    initialValues: {
      firstname: "",
      lastname: "",
      email: "",
      whatsapp: "",
      contact: "",
      instagram: "",
      facebook: "",
      linkedin: "",
      website: "",
    },
    validationSchema: Yup.object({
      firstname: Yup.string().required("First name is required"),
      lastname: Yup.string().required("Last name is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      whatsapp: Yup.string().required("WhatsApp mobile number is required"),
      contact: Yup.string().required("Contact number is required"),
      instagram: Yup.string().url("Invalid URL"),
      facebook: Yup.string().url("Invalid URL"),
      linkedin: Yup.string().url("Invalid URL"),
      website: Yup.string().url("Invalid URL"),
    }),
    onSubmit: values => {
      // Handle form submission here
      let requestBody = {
        section: "about",
        data: {
          first_name: values.firstname,
          last_name: values.lastname,
          mobile_no: values.whatsapp,
          contact_no: values.contact,
          email_id: values.email,
          facebook_link: values.facebook,
          linkedin_link: values.linkedin,
          website_link: values.website,
          instagram_link: values.instagram,
        },
      }
      props.submitProfileChanges(requestBody)
    },
  })

  return (
    <form onSubmit={formik.handleSubmit}>
      <div>
        {/* Basic Information */}
        <Card className="mb-4">
          <CardBody className="p-0">
            <h5 className="nom-title mt-4">Basic Information</h5>

            <Row>
              <Col md="6">
                <div className="mb-3">
                  <Label htmlFor="firstname" className="form-label">
                    First Name <span className="text-danger">*</span>
                  </Label>
                  <Input
                    id="firstname"
                    name="firstname"
                    type="text"
                    className="form-control"
                    placeholder="Enter your first name"
                    value={formik.values.firstname}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.firstname && formik.errors.firstname
                        ? true
                        : false
                    }
                  />
                  {formik.touched.firstname && formik.errors.firstname && (
                    <div className="text-danger small mt-1">
                      {formik.errors.firstname}
                    </div>
                  )}
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3">
                  <Label htmlFor="lastname" className="form-label">
                    Last Name <span className="text-danger">*</span>
                  </Label>
                  <Input
                    id="lastname"
                    name="lastname"
                    type="text"
                    className="form-control"
                    placeholder="Enter your last name"
                    value={formik.values.lastname}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.lastname && formik.errors.lastname
                        ? true
                        : false
                    }
                  />
                  {formik.touched.lastname && formik.errors.lastname && (
                    <div className="text-danger small mt-1">
                      {formik.errors.lastname}
                    </div>
                  )}
                </div>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <div className="mb-3">
                  <Label htmlFor="whatsapp" className="form-label">
                    WhatsApp Mobile Number{" "}
                    <span className="text-danger">*</span>
                  </Label>
                  <Input
                    id="whatsapp"
                    name="whatsapp"
                    type="tel"
                    className="form-control"
                    placeholder="Enter your WhatsApp number"
                    disabled
                    value={formik.values.whatsapp}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.whatsapp && formik.errors.whatsapp
                        ? true
                        : false
                    }
                  />
                  {formik.touched.whatsapp && formik.errors.whatsapp && (
                    <div className="text-danger small mt-1">
                      {formik.errors.whatsapp}
                    </div>
                  )}
                </div>
              </Col>

              <Col md="6">
                <div className="mb-3">
                  <Label htmlFor="contact" className="form-label">
                    Contact Number <span className="text-danger">*</span>
                  </Label>
                  <Input
                    id="contact"
                    name="contact"
                    type="tel"
                    className="form-control"
                    placeholder="Enter your contact number"
                    value={formik.values.contact}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.contact && formik.errors.contact
                        ? true
                        : false
                    }
                  />
                  {formik.touched.contact && formik.errors.contact && (
                    <div className="text-danger small mt-1">
                      {formik.errors.contact}
                    </div>
                  )}
                </div>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <div className="mb-3">
                  <Label htmlFor="email" className="form-label">
                    Email <span className="text-danger">*</span>
                  </Label>
                  <Input
                    id="email"
                    name="email"
                    type="email"
                    className="form-control"
                    placeholder="Enter your email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.email && formik.errors.email ? true : false
                    }
                  />
                  {formik.touched.email && formik.errors.email && (
                    <div className="text-danger small mt-1">
                      {formik.errors.email}
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {/* Social Links */}
        <Card className="mb-4">
          <CardBody className="p-0">
            <h5 className="nom-title mt-4">Social Links</h5>

            <Row>
              <Col md="6">
                <div className="mb-3">
                  <Label htmlFor="instagram" className="form-label">
                    <i className="bx bxl-instagram me-2"></i>
                    Instagram
                  </Label>
                  <Input
                    id="instagram"
                    name="instagram"
                    type="text"
                    className="form-control"
                    placeholder="Instagram Link"
                    value={formik.values.instagram}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.instagram && formik.errors.instagram
                        ? true
                        : false
                    }
                  />
                  {formik.errors.instagram && (
                    <div className="text-danger small mt-1">
                      {formik.errors.instagram}
                    </div>
                  )}
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3">
                  <Label htmlFor="facebook" className="form-label">
                    <i className="bx bxl-facebook me-2"></i>
                    Facebook
                  </Label>
                  <Input
                    id="facebook"
                    name="facebook"
                    type="text"
                    className="form-control"
                    placeholder="Facebook Link"
                    value={formik.values.facebook}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.facebook && formik.errors.facebook
                        ? true
                        : false
                    }
                  />
                  {formik.errors.facebook && (
                    <div className="text-danger small mt-1">
                      {formik.errors.facebook}
                    </div>
                  )}
                </div>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <div className="mb-3">
                  <Label htmlFor="linkedin" className="form-label">
                    <i className="bx bxl-linkedin me-2"></i>
                    LinkedIn
                  </Label>
                  <Input
                    id="linkedin"
                    name="linkedin"
                    type="text"
                    className="form-control"
                    placeholder="Linkedin Link"
                    value={formik.values.linkedin}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.linkedin && formik.errors.linkedin
                        ? true
                        : false
                    }
                  />
                  {formik.errors.linkedin && (
                    <div className="text-danger small mt-1">
                      {formik.errors.linkedin}
                    </div>
                  )}
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3">
                  <Label htmlFor="website" className="form-label">
                    <i className="bx bx-globe me-2"></i>
                    Website
                  </Label>
                  <Input
                    id="website"
                    name="website"
                    type="url"
                    className="form-control"
                    placeholder="Website Link"
                    value={formik.values.website}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.website && formik.errors.website
                        ? true
                        : false
                    }
                  />
                  {formik.errors.website && (
                    <div className="text-danger small mt-1">
                      {formik.errors.website}
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <div className="d-flex justify-content-end">
          <Button color="primary" type="submit">
            Save Changes
          </Button>
        </div>
      </div>
    </form>
  )
}

export default Info
